import { render } from "./BodyCell.vue?vue&type=template&id=487ff6fa"
import script from "./BodyCell.vue?vue&type=script&lang=js"
export * from "./BodyCell.vue?vue&type=script&lang=js"
script.render = render

export default script